import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import React from 'react';
import { PHONE_SEARCH_PAGE_SIZE } from '../constants';
import useStyles from '../styles';

// Bảng danh sách thiết bị khi tìm theo SĐT. results: { query, phone, list, total, page }
const PhoneSearchResults = ({ results, loadingPage, openingSerial, onSelect, onChangePage }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Paper className={classes.resultCard} elevation={0}>
      <Box className={classes.resultHeader}>
        <Box className={classes.resultHeaderIcon}>
          <PhoneIphoneIcon style={{ fontSize: 20 }} />
        </Box>
        <Box flex={1} minWidth={0}>
          <Typography className={classes.plainTitle}>Kết quả tìm kiếm</Typography>
          <Typography className={classes.resultSubtitle}>
            <b>{results.total}</b> thiết bị khớp số điện thoại <b>{results.query}</b>
          </Typography>
        </Box>
        <Typography className={classes.resultHint}>Chọn một dòng để xem chi tiết</Typography>
      </Box>

      <TableContainer className={classes.resultTable}>
        <Table stickyHeader className={classes.resultTableInner}>
          <TableHead>
            <TableRow>
              <TableCell width={56} align="center">STT</TableCell>
              <TableCell>Serial</TableCell>
              <TableCell>Biển số</TableCell>
              <TableCell>Khách hàng</TableCell>
              <TableCell>Số điện thoại</TableCell>
              <TableCell>Đại lý</TableCell>
              <TableCell width={40} />
            </TableRow>
          </TableHead>
          <TableBody className={loadingPage ? classes.resultBodyLoading : undefined}>
            {results.list.map((row, idx) => {
              const rowKey = row.device_id || row.serial || idx;
              const isOpening = openingSerial && openingSerial === (row.serial || row.license_plate);
              return (
                <TableRow
                  key={rowKey}
                  className={`${classes.resultRow} ${isOpening ? classes.resultRowActive : ''}`}
                  onClick={() => !openingSerial && !loadingPage && onSelect(row)}
                >
                  <TableCell align="center">
                    {isOpening ? (
                      <CircularProgress size={16} />
                    ) : (
                      (results.page - 1) * PHONE_SEARCH_PAGE_SIZE + idx + 1
                    )}
                  </TableCell>
                  <TableCell>{row.serial || '--'}</TableCell>
                  <TableCell>{row.license_plate || '--'}</TableCell>
                  <TableCell>
                    <span className={classes.ellipsisText} title={row.end_user_name || ''}>
                      {row.end_user_name?.trim() || '--'}
                    </span>
                  </TableCell>
                  <TableCell>{row.end_user_phone || '--'}</TableCell>
                  <TableCell>
                    <span className={classes.ellipsisText} title={row.agency_name || ''}>
                      {row.agency_name || '--'}
                    </span>
                  </TableCell>
                  <TableCell align="right" className={classes.chevronCell}>
                    <ChevronRightIcon className={classes.rowChevron} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Box className={classes.resultPagination}>
        <Typography style={{ fontSize: '14px' }}>Tổng: {results.total}</Typography>
        <Pagination
          count={Math.ceil(results.total / PHONE_SEARCH_PAGE_SIZE)}
          color="primary"
          size="small"
          onChange={onChangePage}
          page={results.page}
          disabled={loadingPage}
          siblingCount={isMobile ? 0 : 1}
          boundaryCount={isMobile ? 1 : 2}
          showFirstButton={!isMobile}
          showLastButton={!isMobile}
        />
      </Box>
    </Paper>
  );
};

export default PhoneSearchResults;
